import { z, ZodType } from 'zod';

const synchronizePowerFlowDirection = <T extends ZodType>(schema: T): z.ZodEffects<T> => {
    return z.preprocess<T>((object) => {
        const clone = object ? JSON.parse(JSON.stringify(object)) : {};

        if (clone.ports?.length === 2) {
            const firstPortPowerFlowDirection = clone.ports[0].powerFlowDirection;

            if (firstPortPowerFlowDirection === 'bidirectional') {
                clone.ports[1].powerFlowDirection = 'bidirectional';
            }

            if (firstPortPowerFlowDirection === 'input') {
                clone.ports[1].powerFlowDirection = 'output';
            }

            if (firstPortPowerFlowDirection === 'output') {
                clone.ports[1].powerFlowDirection = 'input';
            }
        }

        return clone;
    }, schema);
};

export { synchronizePowerFlowDirection };
